import _classCallCheck from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FieldWrap from '../FieldWrap/FieldWrap';

var GenericInput =
/*#__PURE__*/
function (_Component) {
  _inherits(GenericInput, _Component);

  function GenericInput() {
    _classCallCheck(this, GenericInput);

    return _possibleConstructorReturn(this, _getPrototypeOf(GenericInput).apply(this, arguments));
  }

  _createClass(GenericInput, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          input = _this$props.input,
          label = _this$props.label,
          placeholder = _this$props.placeholder,
          displayNotes = _this$props.displayNotes,
          type = _this$props.type,
          meta = _this$props.meta;
      return React.createElement('div', {
        className: 'form-group'
      }, React.createElement('label', null, label), React.createElement(FieldWrap, {
        meta: meta,
        displayNotes: displayNotes
      }, React.createElement('input', _extends({}, input, {
        className: 'form-control',
        type: type,
        placeholder: placeholder
      }))));
    }
  }]);

  return GenericInput;
}(Component);

GenericInput.propTypes = {
  input: PropTypes.object.isRequired,
  label: PropTypes.element.isRequired,
  placeholder: PropTypes.string,
  displayNotes: PropTypes.string,
  type: PropTypes.string.isRequired,
  meta: PropTypes.object.isRequired
};
export default GenericInput;